import { render } from "./MunicipioUfPerfilDados.vue?vue&type=template&id=13c75fac&ts=true"
import script from "./MunicipioUfPerfilDados.vue?vue&type=script&lang=ts"
export * from "./MunicipioUfPerfilDados.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Municipios/MunicipioUfPerfilDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13c75fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13c75fac', __exports__)) {
    api.reload('13c75fac', __exports__)
  }
  
  module.hot.accept("./MunicipioUfPerfilDados.vue?vue&type=template&id=13c75fac&ts=true", () => {
    api.rerender('13c75fac', render)
  })

}


export default __exports__